// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"489":"bb3eb223e9b7354f1173","793":"ea821ee43878085ef69c","845":"89c2df0b2d5fce5336ed"}[chunkId] + ".bundle.js";
};